import { connect } from 'react-redux';
import { CookiesPolicy } from '../../components';

export default connect(null)(CookiesPolicy);